/* eslint-disable max-len */
import * as React from 'react';

import { CloseButtonProps } from 'react-toastify';

const CROSS_PATH =
  'M15.8327 5.34163L14.6577 4.16663L9.99935 8.82496L5.34102 4.16663L4.16602 5.34163L8.82435 9.99996L4.16602 14.6583L5.34102 15.8333L9.99935 11.175L14.6577 15.8333L15.8327 14.6583L11.1743 9.99996L15.8327 5.34163Z';

export function ToastCloseButton({
  closeToast,
  color,
}: Partial<CloseButtonProps> & { color: string }): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      role="button"
      aria-label="close"
      onClick={closeToast as React.MouseEventHandler}
    >
      <path d={CROSS_PATH} fill={color} />
      <path d={CROSS_PATH} fill="black" fillOpacity="0.6" />
    </svg>
  );
}

export const toastCloseButton =
  (color: string) =>
  ({ closeToast }: CloseButtonProps): React.ReactElement =>
    React.createElement(ToastCloseButton, { closeToast, color });
